export default {
	init() {
		this.onMenuToggle = this.onMenuToggle.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.outsideClick = this.outsideClick.bind(this);
		this.header =  document.querySelector('header.header');
		this.menu = document.querySelector('#main-menu');
		this.menuToggle = document.querySelector('.menu-toggle');
		this.menuToggle.addEventListener('click', this.onMenuToggle);
		window.addEventListener('scroll', this.onScroll);
		document.addEventListener('click', this.outsideClick);
	},
	onMenuToggle() {
		this.menuToggle.classList.toggle('is-active');
		this.menu.classList.toggle('in');
	},
	onScroll() {
		if(document.querySelector('.hero')) {
			const top = document.querySelector('.hero').getBoundingClientRect().height - this.header.getBoundingClientRect().height;
			this.header.classList.toggle('in', window.scrollY > top);
		}
	},
	outsideClick(event) {
		if (event.target.closest('#main-menu') || event.target.closest('#nav-main')) return;
		this.menuToggle.classList.remove('is-active');
		this.menu.classList.remove('in');
		document.removeEventListener('click', this.closeListener);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/header.js